import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Import your SVG asset (adjust the path as needed)
import NoAccessIllustration from '../../assets/no-access.svg';

function NoAccess() {
  const { t } = useTranslation();

  return (
    <div className='mx-auto my-8 w-[94%] max-w-2xl rounded-3xl border border-slate-200 bg-white p-6 text-center shadow-[0_16px_38px_rgba(15,23,42,0.08)] sm:p-8'>
      <img
        src={NoAccessIllustration}
        alt="No Access"
        className='mx-auto mb-4 w-full max-w-[300px]'
        style={{ maxWidth: '300px' }}
      />
      <h2 className='text-2xl font-bold text-slate-900'>{t('no-access.heading')}</h2>
      <p className='mt-2 text-slate-600'>{t('no-access.message')}</p>
      <Link to="/" className='mt-4 inline-flex items-center rounded-full bg-[#1739bd] px-5 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-indigo-700'>
        {t('no-access.backHome')}
      </Link>
    </div>
  );
}

export default NoAccess;
